__turbopack_context__.v({
  "backButton": "VerifyEmail-module__BpWM7W__backButton",
  "button": "VerifyEmail-module__BpWM7W__button",
  "card": "VerifyEmail-module__BpWM7W__card",
  "container": "VerifyEmail-module__BpWM7W__container",
  "editButton": "VerifyEmail-module__BpWM7W__editButton",
  "emailSent": "VerifyEmail-module__BpWM7W__emailSent",
  "emailStep": "VerifyEmail-module__BpWM7W__emailStep",
  "emailVerified": "VerifyEmail-module__BpWM7W__emailVerified",
  "error": "VerifyEmail-module__BpWM7W__error",
  "fadeIn": "VerifyEmail-module__BpWM7W__fadeIn",
  "fadeInUp": "VerifyEmail-module__BpWM7W__fadeInUp",
  "formActionsRow": "VerifyEmail-module__BpWM7W__formActionsRow",
  "formGroup": "VerifyEmail-module__BpWM7W__formGroup",
  "icon": "VerifyEmail-module__BpWM7W__icon",
  "loader": "VerifyEmail-module__BpWM7W__loader",
  "loading": "VerifyEmail-module__BpWM7W__loading",
  "message": "VerifyEmail-module__BpWM7W__message",
  "passwordToggle": "VerifyEmail-module__BpWM7W__passwordToggle",
  "pulseError": "VerifyEmail-module__BpWM7W__pulseError",
  "pulseSuccess": "VerifyEmail-module__BpWM7W__pulseSuccess",
  "redirectMessage": "VerifyEmail-module__BpWM7W__redirectMessage",
  "resendButton": "VerifyEmail-module__BpWM7W__resendButton",
  "resendContainer": "VerifyEmail-module__BpWM7W__resendContainer",
  "secondary": "VerifyEmail-module__BpWM7W__secondary",
  "shakeError": "VerifyEmail-module__BpWM7W__shakeError",
  "spin": "VerifyEmail-module__BpWM7W__spin",
  "spinner": "VerifyEmail-module__BpWM7W__spinner",
  "success": "VerifyEmail-module__BpWM7W__success",
  "title": "VerifyEmail-module__BpWM7W__title",
  "verificationStatus": "VerifyEmail-module__BpWM7W__verificationStatus",
});
